import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const Spark = ({ points, up }) => {
  if (points.length < 2) return null;
  const min = Math.min(...points), max = Math.max(...points), w = 120, h = 26;
  const d = points.map((p, i) => `${(i / (points.length - 1)) * w},${h - ((p - min) / (max - min || 1)) * h}`).join(" ");
  const color = up ? "rgb(var(--bt-positive))" : "rgb(var(--bt-negative))";
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} className="overflow-visible" aria-hidden="true">
      <polyline points={d} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
};

const fmtPrice = (v) => v >= 1000 ? v.toLocaleString(undefined, { maximumFractionDigits: 0 }) : v.toFixed(2);

export default function MarketPulse() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const load = () => axios.get(`${BACKEND}/api/market/pulse`).then(r => setItems(r.data.items || [])).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => go((i) => (i + 1) % items.length), 5000);
    return () => clearInterval(t);
  }, [items.length, idx]);

  const go = (next) => {
    setFade(false);
    setTimeout(() => { setIdx(next); setFade(true); }, 250);
  };

  const p = items[idx % (items.length || 1)];
  if (!p) return null;
  const up = p.change_pct >= 0;
  const label = p.symbol === "BTC" ? "Bitcoin (BTC) · 24/7" : `${p.name} (${p.symbol})${p.is_open ? "" : " · last session"}`;
  return (
    <div className="mt-6 px-3 py-2 border border-bt-border-subtle bg-bt-surface-2/60" data-testid="login-market-pulse">
      <div className={`flex items-center gap-3 transition-opacity duration-300 ${fade ? "opacity-100" : "opacity-0"}`}>
        <div className="font-mono text-[11px] leading-tight min-w-0">
          <p className="text-bt-text-tertiary uppercase tracking-wider text-[9px]" data-testid="login-market-pulse-label">{label}</p>
          <p className="text-bt-text-primary">
            ${fmtPrice(p.price)}{" "}
            <span className={up ? "text-bt-positive" : "text-bt-negative"} data-testid="login-market-pulse-change">{up ? "+" : ""}{p.change_pct.toFixed(2)}%</span>
          </p>
        </div>
        <div className="ml-auto"><Spark key={p.symbol} points={p.points} up={up} /></div>
      </div>
      {items.length > 1 && (
        <div className="flex justify-center gap-1.5 mt-1.5">
          {items.map((it, i) => (
            <button key={it.symbol} onClick={() => go(i)} aria-label={`Show ${it.name}`} data-testid={`login-market-pulse-dot-${it.symbol}`}
              className={`h-1.5 rounded-full transition-all duration-300 ${i === idx ? "w-4 bg-bt-gold" : "w-1.5 bg-bt-text-tertiary/50 hover:bg-bt-text-tertiary"}`} />
          ))}
        </div>
      )}
    </div>
  );
}
